import { FunctionComponent } from 'react';
import Trans from 'next-translate/Trans';
import { useAppContext } from '../../../../providers/app-context';

const SEOContent: FunctionComponent<{
  withPart: boolean;
  stock: string;
  info: any;
  vehicle: any;
}> = ({ withPart, stock, info, vehicle }) => {
  const { businessValues } = useAppContext();
  return (
    <>
      <div className="lg:text-left text-[14px] leading-[24px] max-lg:text-base">
        <div className="container mx-auto px-4 pt-4 flex flex-col gap-2 text-justify">
          {withPart ? (
            <>
              <Trans
                i18nKey={'models:seo-content.with-part'}
                components={{ p: <p /> }}
                values={{
                  brand: vehicle.brand.name || '',
                  vehicle: `${vehicle.brand.name || ''}`,
                  part: info?.subCategory || '',
                  totalStockAvailable:
                    businessValues.totalStockAvailable.defaultValue,
                }}
              />
            </>
          ) : (
            <>
              <Trans
                i18nKey={'models:seo-content.no-part'}
                components={{ p: <p /> }}
                values={{
                  vehicle: `${vehicle.brand.name || ''}`,
                  count: stock,
                }}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SEOContent;
